import React from "react";

interface ModuleFilterTagsProps {
  filters: readonly string[];
  selectedFilters: string[];
  onFilterChange: (filter: string) => void;
}

export const ModuleFilterTags: React.FC<ModuleFilterTagsProps> = ({
  filters,
  selectedFilters,
  onFilterChange,
}) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "6px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {filters.map((filter) => (
        <button
          key={filter}
          onClick={() => onFilterChange(filter)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            border: "1px solid #e0e0e0",
            borderRadius: "6px",
            backgroundColor: selectedFilters.includes(filter)
              ? "#731DCF"
              : "white",
            color: selectedFilters.includes(filter) ? "white" : "#212121",
            fontSize: "14px",
            cursor: "pointer",
            outline: "none",
          }}
        >
          {filter}
        </button>
      ))}
    </div>
  );
};
